module.exports = __webpack_public_path__ + "img/earth.0764dac1.svg";